/* eslint-disable import/prefer-default-export */
/**
 * @deprecated
 * 고객사
 * @type {Object}
 */
export const customer = {
  SKCC: 'SKCC', // SKCC
  SKS: 'SKS', // SK 실트론
  SKT: 'SKT', // SKT 인프라
};



// WEBPACK FOOTER //
// ./src/constants/customer-define.js